import { globalApi as api } from '../../api';

// export const uploadClientMaster = async (fileData) => {
//   try {
//     const formData = new FormData();
//     formData.append('file', fileData);
//     const token = sessionStorage.getItem('token');
//     const response = await api.post('/upload_client_master', formData, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       }
//     });
//     console.log(response.data);
//     return response.data;
//   } catch (error) {
//     throw error.response ? error.response.data.error : error.message;
//   }
// };



export const uploadClientMaster = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_client_master', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};



export const fetchClients = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const user = sessionStorage.getItem('user');
    const company_code = user ? JSON.parse(user).company_code : null;
    const response = await api.get(`/clients/${company_code}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

// export const updateClient = async (id, clientData) => {
//   try {
//     const response = await api.put(`/clients/${id}`, clientData);
//     return response.data;
//   } catch (error) {
//     throw error.response ? error.response.data.error : error.message;
//   }
// };
export const updateClient = async (id, clientData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/clients/${id}`, clientData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const deleteClient = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/clients/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const clientMasterDataInput = async (ClientDataInput) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/client_master_single_entry', ClientDataInput, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {    
    throw error.response ? error.response.data.error : error.message;
  }
};
export const multiDeleteClientMaster = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multipleClients', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};


export const getClientImportantBackup = async (current_month) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get_clients/${current_month}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    const data = error.response?.data;
    if (data?.message) {
      throw data.message;
    }
    throw error.response?.data?.error || error.message;
  }
};